import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import numeral from 'numeral';

import Box from '../Box';
import { Text } from '../Text';

const LIGHT_GRAY = '#f0f0f0';

const LABEL_POSITION = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
};

const FixedBar = styled(({ bg = LIGHT_GRAY, width = 100, height, ...props }) => (
  <Box bg={bg} width={`${width}%`} height={height} {...props} />
))`
  height: ${({ height }) => height};
  margin: 6px 0 0 0;
  border-radius: ${({ $withRadius = true }) => ($withRadius ? '20px' : '0px')};
`;

const ProgressBar = ({
  value,
  label,
  textProps,
  withLabel,
  withRadius,
  labelPosition,
  progressColor,
  barProps,
  barContainerProps,
  height,
  ...restProps
}) => {
  let percent = value;
  if (value > 100) percent = 100;
  else if (value < 0) percent = 0;
  return (
    <Box {...restProps}>
      {labelPosition === LABEL_POSITION.TOP && withLabel && (
        <Text color="secondary" {...textProps}>
          {`${numeral(percent).format('0[.][00]')}% ${label}`}
        </Text>
      )}
      <FixedBar height={height} $withRadius={withRadius} {...barContainerProps}>
        <FixedBar
          width={percent}
          bg={progressColor}
          height={height}
          $withRadius={withRadius}
          {...barProps}
        />
      </FixedBar>
      {labelPosition === LABEL_POSITION.BOTTOM && withLabel && (
        <Text color="secondary" {...textProps}>
          {`${numeral(percent).format('0[.][00]')}% ${label}`}
        </Text>
      )}
    </Box>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  withLabel: PropTypes.bool,
  withRadius: PropTypes.bool,
  progressColor: PropTypes.string,
  barProps: PropTypes.object,
  barContainerProps: PropTypes.object,
  height: PropTypes.string,
  appConfig: PropTypes.object,
  labelPosition: PropTypes.oneOf(Object.values(LABEL_POSITION)),
};

ProgressBar.defaultProps = {
  value: 0,
  withLabel: true,
  withRadius: true,
  progressColor: 'primary',
  labelPosition: LABEL_POSITION.TOP,
  height: '4px',
};

ProgressBar.LABEL_POSITION = LABEL_POSITION;

export default ProgressBar;
